import { ChangeDetectionStrategy, Component, inject, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService, TreeNode } from 'primeng/api';
import { TreeModule } from 'primeng/tree';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';
import { finalize, forkJoin } from 'rxjs';
import { ChopMassnahme } from '@entity/chop';
import { ChopService } from '@service/chop.service';
import { TranslateService } from '@ngx-translate/core';
import { buildMassnahmenTree, currentLanguage, showTacsCodeKreisError } from '../massnahmen-tree';

@Component({
  selector: 'app-chop-profil-massnahme-dialog',
  templateUrl: './chop-profil-massnahme-dialog.component.html',
  styleUrls: ['./chop-profil-massnahme-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, TreeModule, ButtonModule, TranslatePipe],
})
export class ChopProfilMassnahmeDialogComponent {
  private dialogConfig = inject(DynamicDialogConfig);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private dialogRef = inject(DynamicDialogRef);
  private chopService = inject(ChopService);
  private translateService = inject(TranslateService);
  private messageService = inject(MessageService);

  private profilId: number = this.dialogConfig.data.profilId;
  private alreadyAssignedIds = new Set<number>(this.dialogConfig.data.alreadyAssignedIds ?? []);
  treeNodes: TreeNode<ChopMassnahme>[] = buildMassnahmenTree(
    this.dialogConfig.data.allMassnahmen,
    currentLanguage(this.translateService),
    {
      disabledIds: this.alreadyAssignedIds,
    }
  );
  selection: TreeNode<ChopMassnahme>[] = [];
  submitting = false;

  onSubmit(): void {
    const selectedIds = this.selection
      .filter((n) => n.data && n.data?.isMassnahme && !this.alreadyAssignedIds.has(n.data.id))
      .map((n) => n.data!.id);
    if (selectedIds.length === 0) {
      return;
    }
    this.submitting = true;
    forkJoin(selectedIds.map((id) => this.chopService.addProfilMassnahme(this.profilId, id)))
      .pipe(finalize(() => (this.submitting = false)))
      .subscribe({
        next: (results) => this.dialogRef.close(results),
        error: (err) => showTacsCodeKreisError(this.messageService, this.translateService, err),
      });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
